import Vue from 'vue'
import firebase from './firebase'

// Crear un plugin para hacer firebase accesible globalmente
const FirebasePlugin = {
  install (Vue) {
    // Agregar $firebase a la instancia de Vue
    Vue.prototype.$firebase = firebase

    // También podemos agregar métodos de utilidad
    Vue.prototype.$auth = firebase.auth()
    Vue.prototype.$db = firebase.firestore()
    Vue.prototype.$storage = firebase.storage()
    Vue.prototype.$functions = firebase.functions()
  }
}

// Instalar el plugin
Vue.use(FirebasePlugin)

export default FirebasePlugin
